import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../../client";

const SERVICE_QUERY = `*[_type == "ServiceCategory"]{
  _id,
  title,
  slug
}`;

export default function OtherPages() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    client.fetch(SERVICE_QUERY).then((data) => {
      setServices(data);
    });
  }, []);

  return (
    <div className="head-container">
      <h2>Services</h2>

      <ul>
        {services.map((service) => {
          const slug = service?.slug?.current;
          if (!slug) return null;

          return (
            <li key={service._id}>
              <Link to={`/${slug}`}>{service.title}</Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}